const BASE_URL = 'dash.v1.alictuscloud.com';
const LOGGER_URL = 'logger.alictusapi.com:54290';
const API_ENDPOINT = `https://${BASE_URL}`;
const LOGGER_ENDPOINT = `https://${LOGGER_URL}`;
const WEBSOCKET_ENDPOINT = `wss://${BASE_URL}`;
const LOGGER_WEBSOCKET_ENDPOINT = `wss://${LOGGER_URL}`;


const config = {
  API_ENDPOINT,
  LOGGER_ENDPOINT,
  WEBSOCKET_ENDPOINT,
  LOGGER_WEBSOCKET_ENDPOINT
};

export default config;